import { State } from "@/state";
import { useColorScheme } from "@/hooks/useColorScheme";
import { useLayoutEffect, useRef } from "react";
import { MoonIcon, SunIcon } from "lucide-react";

export const COMMAND_ID = "toggle-color-scheme";

export type ToggleColorSchemeContextType = Record<string, never>;

export function ToggleColorSchemeCommand() {
  const registerCommandDefinition = State(
    (state) => state.registerCommandDefinition,
  );
  const unregisterCommandDefinition = State(
    (state) => state.unregisterCommandDefinition,
  );

  const { setColorScheme } = useColorScheme();
  // Store setColorScheme in a ref so the registration closure always has the latest
  const setColorSchemeRef = useRef(setColorScheme);
  setColorSchemeRef.current = setColorScheme;

  useLayoutEffect(() => {
    registerCommandDefinition({
      id: COMMAND_ID,
      title: "Toggle Color Scheme",
      getTitle: () => {
        const isDark = document.documentElement.classList.contains("dark");
        return isDark ? "Dark Mode → Light Mode" : "Light Mode → Dark Mode";
      },
      description: "Toggle the color scheme",
      onClick: () => {
        const isDark = document.documentElement.classList.contains("dark");
        setColorSchemeRef.current(isDark ? "light" : "dark");
        State.getState().clearCommandStack();
      },
      ReactIcon: SunIcon,
      group: "Appearance",
    });

    return () => {
      unregisterCommandDefinition(COMMAND_ID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
